import { BaseModel } from './baseModel';

export class FileType extends BaseModel {

  constructor(
    public type: string,
    public name: string
  ) { super(); }
}
